import { createI18n } from 'vue-i18n';
import es from '../lang/es.json';
import ca from '../lang/ca.json';

const messages = {
  es,
  ca
};

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'es',
  fallbackLocale: 'es',
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  missingWarn: false,
  fallbackWarn: false
});

export default i18n;
